import core, { Viewport } from '@gin-betting/core';

import { DEFAULT_BREAKPOINTS } from 'app-constants';

const {
    utils: { checkMobile },
} = core;

class UserDevice {
    static readonly mockMobileDevice: Required<Viewport.DeviceMock> = {
        type: 'screen',
        width: `${DEFAULT_BREAKPOINTS.superExtraSmall}px`,
        orientation: '(orientation: portrait)',
    };
    static readonly mockDesktopDevice: Required<Viewport.DeviceMock> = {
        type: 'screen',
        width: `${DEFAULT_BREAKPOINTS.extraLarge}px`,
        orientation: '(orientation: landscape)',
    };

    private static instance: UserDevice | undefined = undefined;

    private readonly isMobile: boolean;

    private constructor(userAgent?: string) {
        this.isMobile = checkMobile(userAgent);
    }

    static init(userAgent?: string): UserDevice {
        return (this.instance = new UserDevice(userAgent));
    }

    static getInstance(): UserDevice | null {
        if (!this.instance) {
            try {
                throw new Error('UserDevice is used before initialized!');
            } catch (error) {
                console.error(error);
            }

            return null;
        }

        return this.instance;
    }

    public isDeviceMobile(): boolean {
        return this.isMobile;
    }
}

export default UserDevice;
